/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

module.exports = function(it, Constructor, name){
  if(!(it instanceof Constructor))throw TypeError(name + ": use the 'new' operator!");
  return it;
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/library/modules/$.strict-new.js
 ** module id = 508
 ** module chunks = 0
 **/